import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import { mergeMap, catchError } from "rxjs/operators";
import { push } from "react-router-redux";
import { notification } from "antd";
import { pendingTask, begin, end } from "react-redux-spinner";
import normalize from "json-api-normalizer";
import { parseError } from "./lib";
import PatientService from "../services/patientService";
import { FORM_ERROR } from "final-form";

import {
  saveUserSuccess,
  SAVE_USER_SUCCESS_ACTION,
  // SEND_REMINDER_PATIENT_REQUEST_ACTION,
  // sendReminderPatientSuccess,
  // sendReminderPatientFailure,
  // SEND_PUSH_NOTIFICATION_REQUEST_ACTION,
  //sendPushNotificationFailure,
  //sendPushNotificationSuccess,
  DELETE_TASK_SUCCESS_ACTION,
  LOAD_ACTIVITY_REQUEST_ACTION,
  loadActivitySuccess,
  loadActiveAccountFailure,
  loadActivityFailure,
  loadPatientsSuccess,
  LOAD_PATIENTS_REQUEST_ACTION,
  loadPatientsFailure
} from "../ducks/data";

import {
  SEND_REMINDER_PATIENT_REQUEST_ACTION,
  sendReminderPatientSuccess,
  sendReminderPatientFailure,
  SEND_PUSH_NOTIFICATION_REQUEST_ACTION,
  sendPushNotificationFailure,
  sendPushNotificationSuccess,
  saveProfileFormSuccess,
  saveProfileFormFailure,
  SAVE_PROFILE_FORM_REQUEST_ACTION,
  loadPatientSuccess,
  savePatientRequest,
  savePatientSuccess,
  savePatientFailure,
  LOAD_PATIENT_REQUEST_ACTION,
  SAVE_PATIENT_REQUEST_ACTION,
  SAVE_PATIENT_CONDITION_REQUEST_ACTION,
  savePatientConditionSuccess,
  SAVE_PATIENT_SUCCESS_ACTION,
  SAVE_PATIENT_FAILURE_ACTION,
  LINK_PROGRAM_REQUEST_ACTION,
  linkProgramSuccess,
  loadPatientFailure,
  SAVE_PATIENT_PROGRAM_REQUEST_ACTION,
  savePatientProgramFailure,
  savePatientProgramSuccess,
  DELETE_PATIENT_CONDITION_REQUEST_ACTION,
  deletePatientConditionSuccess,
  deletePatientConditionFailure,
  DELETE_PATIENT_PROGRAM_REQUEST_ACTION,
  deletePatientProgramFailure,
  deletePatientProgramSuccess,
  SAVE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION,
  linkProgramFailure,
  savePatientConditionFailure,
  DELETE_PATIENT_REQUEST_ACTION,
  deletePatientFailure,
  deletePatientSuccess,
  INSERT_PATIENT_PROGRAM_ITEM_REQUEST_ACTION,
  loadPatientProgramRequest,
  LOAD_PATIENT_PROGRAM_REQUEST_ACTION,
  loadPatientProgramSuccess,
  loadPatientProgramFailure,
  savePatientProgramItemSuccess,
  savePatientProgramItemFailure,
  insertPatientProgramItemSuccess,
  insertPatientProgramItemFailure,
  LOAD_PATIENT_FAILURE_ACTION,
  DELETE_SUPPORT_USER_REQUEST_ACTION,
  deleteSupportUserSuccess,
  deleteSupportUserFailure,
  DELETE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION,
  deletePatientProgramItemSuccess,
  deletePatientProgramItemFailure
} from "../ducks/patient";
import { setActiveDialog } from "../ducks/app";

export const loadPatientsEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PATIENTS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .findAll(action.payload)
        .then(response => {
          return loadPatientsSuccess(action.payload, normalize(response.data));
        })
        .catch(error => {
          return loadPatientsFailure(parseError(error));
        });
    })
  );

const _ = require("lodash");
export const loadPatientEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PATIENT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .find(action.payload)
        .then(response => {
          return loadPatientSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadPatientFailure(parseError(error));
        });
    })
  );

export const loadPatientFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PATIENT_FAILURE_ACTION.getType()),
    mergeMap(action => {
      return of(push("/patients"));
    })
  );
export const saveProfileFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROFILE_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(savePatientRequest(action.payload));
    })
  );

export const saveProfileFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(
      SAVE_PATIENT_SUCCESS_ACTION.getType(),
      SAVE_USER_SUCCESS_ACTION.getType()
    ),
    mergeMap(action => {
      return of(saveProfileFormSuccess(action.payload.user));
    })
  );

export const saveProfileFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_FAILURE_ACTION.getType()),
    mergeMap(action => {
      let errors = {
        [FORM_ERROR]: action.payload.title
      };
      // TODO: check result for validation failure or communication failure based on status
      return of(saveProfileFormFailure(errors));
    })
  );

export const savePatientEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();

      return patientService
        .savePatient(action.payload)
        .then(response => {
          return savePatientSuccess(normalize(response.data));
        })
        .catch(error => {
          console.log(error);
          return savePatientFailure(parseError(error));
        });
      //}
    })
  );

export const deletePatientEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_PATIENT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return concat(
        patientService
          .savePatient(action.payload)
          .then(response => {
            return patientService
              .archivePatient(action.payload)
              .then(response => {
                return deletePatientSuccess(action.payload);
              })
              .catch(error => {
                return deletePatientFailure(parseError(error));
              });
          })
          .catch(error => {
            return deletePatientFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );

export const savePatientSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      var id = Object.keys(action.payload.patients.patients)[0];
      return concat(of(setActiveDialog()), of(push(`/patients/${id}`)));
    })
  );

export const savePatientFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_FAILURE_ACTION.getType()),
    mergeMap(action => {
      return setActiveDialog();
    })
  );

export const linkProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(LINK_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .linkProgram(action.payload)
        .then(response => {
          return linkProgramSuccess(normalize(response.data));
        })
        .catch(error => {
          return linkProgramFailure(parseError(error));
        });
    })
  );

export const sendReminderEpic = (action$, state$) =>
  action$.pipe(
    ofType(SEND_REMINDER_PATIENT_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .sendReminder(action.payload)
        .then(response => {
          return sendReminderPatientSuccess();
        })
        .catch(error => {
          return sendReminderPatientFailure(parseError(error));
        });
    })
  );

export const sendPushNotificationEpic = (action$, state$) =>
  action$.pipe(
    ofType(SEND_PUSH_NOTIFICATION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .sendPushNotification(action.payload)
        .then(response => {
          return sendPushNotificationSuccess();
        })
        .catch(error => {
          return sendPushNotificationFailure(parseError(error));
        });
    })
  );

export const savePatientProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return concat(
        patientService
          .savePatientProgram(action.payload)
          .then(response => {
            return savePatientProgramSuccess(normalize(response.data));
          })
          .catch(error => {
            return savePatientProgramFailure(parseError(error));
          })
      );
    })
  );
export const savePatientConditionEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_CONDITION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .savePatientCondition(action.payload)
        .then(response => {
          return savePatientConditionSuccess(normalize(response.data));
        })
        .catch(error => {
          return savePatientConditionFailure(parseError(error));
        });
    })
  );

export const deletePatientProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_PATIENT_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new PatientService();
      return concat(
        service
          .archivePatientProgram(action.payload)
          .then(response => {
            return deletePatientProgramSuccess(action.payload);
          })
          .catch(error => {
            return deletePatientProgramFailure(parseError(error));
          })
      );
    })
  );

export const deletePatientProgramItemEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let activeDialog = state$.value.app.activeDialog;
      let service = new PatientService();
      return concat(
        service
          .archivePatientProgramItem(action.payload)
          .then(response => {
            return deletePatientProgramItemSuccess(action.payload);
          })
          .catch(error => {
            return deletePatientProgramItemFailure(parseError(error));
          }),
        of(
          setActiveDialog(
            _.replace(activeDialog, `-delete-${action.payload.id}`, "")
          )
        )
      );
    })
  );

export const deletePatientConditionEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_PATIENT_CONDITION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new PatientService();
      return concat(
        service
          .archivePatientCondition(action.payload)
          .then(response => {
            return deletePatientConditionSuccess(action.payload);
          })
          .catch(error => {
            return deletePatientConditionFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );

export const deleteSupportUserEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_SUPPORT_USER_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new PatientService();
      return concat(
        service
          .removeSupportUser(action.payload)
          .then(response => {
            return deleteSupportUserSuccess(normalize(response.data));
          })
          .catch(error => {
            return deleteSupportUserFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );

export const savePatientProgramItemEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new PatientService();
      return concat(
        service
          .savePatientProgramItem(action.payload)
          .then(response => {
            return savePatientProgramItemSuccess(normalize(response.data));
          })
          .catch(error => {
            return savePatientProgramItemFailure(parseError(error));
          })
      );
    })
  );

export const insertPatientProgramItemEpic = (action$, state$) =>
  action$.pipe(
    ofType(INSERT_PATIENT_PROGRAM_ITEM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new PatientService();
      return concat(
        service
          .savePatientProgramItem(action.payload)
          .then(response => {
            return insertPatientProgramItemSuccess(normalize(response.data));
          })
          .catch(error => {
            return insertPatientProgramItemFailure(parseError(error));
          }),
        of(
          loadPatientProgramRequest(action.payload.attributes.patientProgramId)
        )
      );
    })
  );

export const loadPatientProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PATIENT_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .findProgram(action.payload)
        .then(response => {
          return loadPatientProgramSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadPatientProgramFailure(parseError(error));
        });
    })
  );

export const loadPatientProgramActivityEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_ACTIVITY_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let patientService = new PatientService();
      return patientService
        .findProgramActivity(action.payload)
        .then(response => {
          return loadActivitySuccess(normalize(response.data));
        })
        .catch(error => {
          return loadActivityFailure(parseError(error));
        });
    })
  );



// WEBPACK FOOTER //
// ./src/epics/patients.js